module.exports = __webpack_public_path__ + "static/media/appway.1ee440ae.png";